/* ============================================================
   Nedtælling på "Hemmelige tilbud til dig" i Upcart-kurven
   (2026-10-09). Markup: snippets/cart-upsell.liquid
   ([data-upsell-cd] inde i .cart-upsell--secret).

   - Uret starter, første gang kunden faktisk SER tilbuddene
     (boksen er synlig på skærmen), og kører 20 minutter (fra 2026-10-12).
   - Det fortsætter, hvis kunden lukker kurven, skifter side eller
     genindlæser siden (gemmes i sessionStorage).
   - Ved 00:00 skjules boksen resten af besøget. Tilbud, der allerede
     er lagt i kurven, beholder deres pris.
   - Lukker kunden hjemmesiden og åbner den igen (nyt besøg), starter
     et nyt 20-minutters ur.
   Indlæses fra sections/label-config.liquid.
   ============================================================ */
(function () {
  if (window.__anewSecretTimer) return;
  window.__anewSecretTimer = true;

  var KEY = 'anewSecretTimerEnd';
  var DURATION = 20 * 60 * 1000;
  var end = 0;
  try { end = Number(sessionStorage.getItem(KEY)) || 0; } catch (e) { end = 0; }

  function fmt(ms) {
    var s = Math.ceil(ms / 1000);
    var m = Math.floor(s / 60);
    s = s % 60;
    return (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
  }

  function isOnScreen(el) {
    var r = el.getBoundingClientRect();
    if (!r.width || !r.height) return false;
    if (r.right <= 0 || r.left >= window.innerWidth || r.bottom <= 0 || r.top >= window.innerHeight) return false;
    var cs = window.getComputedStyle(el);
    return cs.visibility !== 'hidden' && cs.display !== 'none';
  }

  function tick() {
    var blocks = document.querySelectorAll('.cart-upsell--secret');
    if (!blocks.length) return;
    var now = Date.now();
    var i;

    if (!end) {
      // Før uret starter: vis hele tiden (snippet'en skriver 15:00 i markup)
      var full = fmt(DURATION);
      var pre = document.querySelectorAll('[data-upsell-cd]');
      for (i = 0; i < pre.length; i++) {
        if (pre[i].textContent !== full) pre[i].textContent = full;
      }
      var seen = false;
      for (i = 0; i < blocks.length; i++) {
        if (isOnScreen(blocks[i])) { seen = true; break; }
      }
      if (!seen) return;
      end = now + DURATION;
      try { sessionStorage.setItem(KEY, String(end)); } catch (e) {}
    }

    var left = end - now;
    if (left <= 0) {
      for (i = 0; i < blocks.length; i++) {
        if (blocks[i].style.display !== 'none') blocks[i].style.display = 'none';
      }
      return;
    }

    var txt = fmt(left);
    var cds = document.querySelectorAll('[data-upsell-cd]');
    for (i = 0; i < cds.length; i++) {
      if (cds[i].textContent !== txt) cds[i].textContent = txt;
    }
  }

  // Kurven gen-tegnes af Upcart/anew-upcart-upsell.js - reagér med det samme,
  // så en udløbet boks aldrig ses, og tiden er rigtig fra første frame.
  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; tick(); });
  }).observe(document.documentElement, { childList: true, subtree: true });

  setInterval(tick, 1000);
  tick();
})();
